import React from 'react';
import { FiltersProvider } from '../../../../../components/providers/FiltersProvider';
import ContractProfileLayoutWrapper from '../../ContractProfileLayoutWrapper';
import ContractActivityHistory from './ContractActivityHistory';

interface ContractActivityHistoryWrapperProps { }

const ContractActivityHistoryWrapper: React.FC<ContractActivityHistoryWrapperProps> = () => {

    return (
        <FiltersProvider>
            <ContractProfileLayoutWrapper>
                <ContractActivityHistory />
            </ContractProfileLayoutWrapper>
        </FiltersProvider>
    );
};

export default ContractActivityHistoryWrapper;